import { doc, updateDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../config';
import { handleFirebaseError } from '../../error-handling';
import type { ClinicalExam } from '@/components/examiner/types';

export async function updateExam(examId: string, data: Partial<ClinicalExam>): Promise<void> {
  try {
    console.log('📝 updateExam called with examId:', examId, 'data:', data);
    const examRef = doc(db, 'clinicalExams', examId);
    const updateData = {
      ...data,
      updatedAt: Timestamp.now()
    };
    console.log('📝 Data being updated in Firestore:', updateData);
    await updateDoc(examRef, updateData);
    console.log('📝 Update completed successfully');
  } catch (error) {
    handleFirebaseError(error, 'Error updating exam');
    throw error;
  }
}